









interface NodeLegendItem {
  color: string;
  text: string;
}

import {Vue, Component, Prop} from 'vue-property-decorator';
@Component({})
export default class NodeLegend extends Vue {
  @Prop({required: true, type: Array})
  data!: NodeLegendItem[];
}
